var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop } from 'vue-property-decorator';
import _, { debounce } from "lodash";
import VueDialog from "../../../interface/IVueDialog";
import BusinessGoodsPriceService from '../../../api/BusinessGoodsPriceService';
import { initClientsRight, formateClientsByGroupTree, goodsPriceCreateResultByClientsRight, fixBusinessIdsContainGroupNotHasChildren, checkedTempGroupData } from '../../../helper/newBusinessGoodsPriceFunc';
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clients = [];
        _this.clientsRight = [];
        _this.supplier_to_business_ids = [];
        _this.group_ids = [];
        _this.business_ids = [];
        _this.needCheckedIsTemp = false;
        _this.extra_selected_shop = [];
        _this.disabled = false;
        _this.shop_ids = [];
        _this.descHtml = '';
        _this.requiredChooseNum = true;
        _this.leftKeyword = '';
        _this.rightKeyword = '';
        _this.rightTreeReady = false;
        _this.defaultProps = {
            label: 'business_name',
            id: "supplier_to_business_id"
        };
        _this.isSelectAll = false;
        _this.indeterminate = false;
        _this.debounceComputedSelectAll = null;
        return _this;
    }
    Dialog.prototype.created = function () {
        this.service = BusinessGoodsPriceService.getInstance();
    };
    Dialog.prototype.mounted = function () {
        this.getClients();
        this.debounceComputedSelectAll = debounce(this.updateSelectAll, 300);
    };
    Dialog.prototype.selectAll = function () {
        if (this.isSelectAll) {
            this.supplier_to_business_ids = this.$refs.tree.getCheckedKeys(true);
            this.$refs.tree.setCheckedNodes(this.clients);
        }
        else {
            this.$refs.tree.setCheckedNodes([]);
        }
    };
    Dialog.prototype.getSelectedBusinessCount = function () {
        return this.clientsRight.reduce(function (count, group) {
            return count + group.children.filter(function (business) { return business.isChk; }).length;
        }, 0);
    };
    Dialog.prototype.getSelectedShopCount = function () {
        return this.clientsRight.reduce(function (count, group) {
            return count + group.children.reduce(function (businessCount, business) {
                return businessCount + business.children.filter(function (shop) { return shop.isChk; }).length;
            }, 0);
        }, 0);
    };
    Dialog.prototype.filterNode = function (value, data) {
        if (!value)
            return true;
        return data.business_name.indexOf(value) !== -1;
    };
    Dialog.prototype.filterNodeRight = function (value, data) {
        if (data.nodeType == 'shop' && !data.isChk) {
            return false;
        }
        if (data.nodeType == 'business') {
            if (data.children && data.children.length > 0) {
                var hasCheckedShop = data.children.some(function (shop) { return shop.isChk; });
                if (!hasCheckedShop) {
                    return false;
                }
            }
            else {
                if (data.isChk) {
                    return true;
                }
                else {
                    return false;
                }
            }
        }
        if (data.nodeType == 'business_group') {
            if (data.children.length > 0) {
                if (!data.chkChildrensNum) {
                    return false;
                }
            }
            else {
                if (data.is_set_group != 1) {
                    return false;
                }
            }
        }
        if (!value)
            return true;
        return data.business_name.indexOf(value) !== -1;
    };
    Dialog.prototype.updateClientsRightByBusinessIds = function () {
        this.clientsRight = initClientsRight(this.clientsRight, this.supplier_to_business_ids);
        this.searchRight();
    };
    Dialog.prototype.updateClientsRightIsSetGroup = function (clientsRight, group_id, checked) {
        clientsRight.forEach(function (v) {
            if (v.group_id == group_id) {
                v.is_set_group = checked ? 1 : 2;
            }
        });
        console.log('this.clientsRight点击后', this.clientsRight);
    };
    Dialog.prototype.updateShopClientsRightIsSetGroup = function (clientsRight, business_id, supplier_to_business_id, checked) {
        clientsRight.forEach(function (v) {
            (v.children || []).forEach(function (business) {
                if (business.business_id == business_id && business.supplier_to_business_id == supplier_to_business_id) {
                    business.is_set_group = checked ? 3 : 4;
                }
            });
        });
    };
    Dialog.prototype.getFlatNodes = function (list) {
        var _this = this;
        var result = [];
        list.forEach(function (item) {
            if (item.nodeType === 'business_group' && (!item.children || item.children.length === 0)) {
                result.push(item);
            }
            else if (item.nodeType === 'shop') {
                result.push(item);
            }
            else if (item.children && Array.isArray(item.children) && item.children.length > 0) {
                result.push.apply(result, _this.getFlatNodes(item.children));
            }
        });
        return result;
    };
    Dialog.prototype.updateSelectAll = function () {
        var allLeafNodes = this.getFlatNodes(this.clients);
        var checkedNodes = this.$refs.tree.getCheckedNodes(false);
        var checkedLeafNodes = checkedNodes.filter(function (node) {
            return node.nodeType === 'shop' ||
                (node.nodeType === 'business_group' && (!node.children || node.children.length === 0));
        });
        this.isSelectAll = allLeafNodes.length === checkedLeafNodes.length;
        this.indeterminate = checkedLeafNodes.length > 0 && checkedLeafNodes.length < allLeafNodes.length;
    };
    Dialog.prototype.handleCheckChange = function (data, checked, indeterminate) {
        console.log('this.supplier_to_business_ids', this.supplier_to_business_ids);
        if (data.nodeType == 'business_group') {
            this.updateClientsRightIsSetGroup(this.clientsRight, data.group_id, checked);
        }
        if (data.nodeType == 'business') {
            this.updateShopClientsRightIsSetGroup(this.clientsRight, data.business_id, data.supplier_to_business_id, checked);
        }
        this.supplier_to_business_ids = this.$refs.tree.getCheckedKeys();
        this.updateClientsRightByBusinessIds();
        this.debounceComputedSelectAll();
    };
    Dialog.prototype.delClient = function (node, data) {
        var _this = this;
        this.supplier_to_business_ids = (this.supplier_to_business_ids || []).filter(function (id) {
            return id !== data.supplier_to_business_id;
        });
        this.shop_ids = (this.shop_ids || []).filter(function (shop) {
            return !(shop.shop_id === data.shop_id &&
                shop.supplier_to_business_id === data.supplier_to_business_id &&
                shop.business_id === data.business_id);
        });
        if (data.parent_supplier_to_business_id) {
            var parentNodeShops_1 = [];
            this.clients.forEach(function (group) {
                (group.children || []).forEach(function (business) {
                    if (business.supplier_to_business_id === data.parent_supplier_to_business_id) {
                        (business.children || []).forEach(function (shop) {
                            if (shop.supplier_to_business_id !== data.supplier_to_business_id) {
                                parentNodeShops_1.push(shop.supplier_to_business_id);
                            }
                        });
                    }
                });
            });
            var selectedShops = parentNodeShops_1.filter(function (shopId) {
                return _this.supplier_to_business_ids.includes(shopId);
            });
            if (selectedShops.length === 0) {
                this.business_ids = (this.business_ids || []).filter(function (item) {
                    return !(item.business_id === data.business_id &&
                        item.supplier_to_business_id === data.parent_supplier_to_business_id);
                });
                this.supplier_to_business_ids = this.supplier_to_business_ids.filter(function (id) {
                    return id !== data.parent_supplier_to_business_id;
                });
            }
        }
        this.updateClientsRightByBusinessIds();
        this.$nextTick(function () {
            if (_this.$refs.tree) {
                try {
                    _this.$refs.tree.setChecked(data.supplier_to_business_id, false, false);
                    if (data.parent_supplier_to_business_id &&
                        !_this.supplier_to_business_ids.includes(data.parent_supplier_to_business_id)) {
                        _this.$refs.tree.setChecked(data.parent_supplier_to_business_id, false, false);
                    }
                    _this.debounceComputedSelectAll();
                }
                catch (error) {
                    console.error('更新树节点选中状态失败:', error);
                    _this.$refs.tree.setCheckedKeys(_this.supplier_to_business_ids);
                }
            }
        });
    };
    Dialog.prototype.changeRightGroupIsSetGroup = function (node, data) {
        if (data.nodeType == 'business_group' && data.is_set_group == 1) {
            data.children.forEach(function (business) {
                business.is_set_group = 3;
            });
        }
        else if (data.nodeType == 'business') {
            var parentGroup = this.clientsRight.find(function (group) {
                return group.group_id === data.group_id;
            });
            if (parentGroup) {
                if (data.is_set_group == 3) {
                    var allClientsEnabled = parentGroup.children.every(function (business) {
                        return business.isChk && business.is_set_group == 3;
                    });
                    if (allClientsEnabled && parentGroup.children.length > 0) {
                        parentGroup.is_set_group = 1;
                    }
                }
                else {
                    parentGroup.is_set_group = 2;
                }
            }
        }
        if (data.nodeType == 'business_group' && data.children.length == 0 && data.is_set_group != 1) {
            this.supplier_to_business_ids = this.supplier_to_business_ids.filter(function (id) {
                return id != data.supplier_to_business_id;
            });
            this.updateClientsRightByBusinessIds();
            this.$refs.tree.setCheckedKeys(this.supplier_to_business_ids);
        }
    };
    Dialog.prototype.clearAllClient = function () {
        this.supplier_to_business_ids = [];
        this.updateClientsRightByBusinessIds();
        this.$refs.tree.setCheckedKeys(this.supplier_to_business_ids);
    };
    Dialog.prototype.processTreeDisabled = function (treeData, disabledIds) {
        if (!treeData || !disabledIds || !disabledIds.length)
            return;
        treeData.forEach(function (group) {
            if (group.children && group.children.length) {
                var allBusinessDisabled_1 = true;
                group.children.forEach(function (business) {
                    if (business.children && business.children.length) {
                        var allShopsDisabled_1 = true;
                        business.children.forEach(function (shop) {
                            var shopKey = shop.supplier_to_business_id;
                            if (disabledIds.includes(shopKey)) {
                                shop.disabled = true;
                            }
                            else {
                                allShopsDisabled_1 = false;
                            }
                        });
                        if (allShopsDisabled_1 && business.children.length > 0) {
                            business.disabled = true;
                        }
                        else {
                            allBusinessDisabled_1 = false;
                        }
                    }
                    else {
                        allBusinessDisabled_1 = false;
                    }
                });
                if (allBusinessDisabled_1 && group.children.length > 0) {
                    group.disabled = true;
                }
            }
        });
    };
    Dialog.prototype.getClients = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.service.getClientsByGroupTree({
                is_have_empty_group: _this.showEmpty ? 1 : 0,
                is_have_shop: 1
            }).then(function (res) {
                res.data.data = formateClientsByGroupTree(res.data.data);
                var new_data = res.data.data || [];
                new_data.sort(function (a, b) { return b.children.length - a.children.length; });
                if (_this.extra_selected_shop && _this.extra_selected_shop.length) {
                    _this.processTreeDisabled(new_data, _this.extra_selected_shop);
                }
                _this.clients = new_data;
                if (_this.needCheckedIsTemp) {
                    var tempGroupData = checkedTempGroupData(_.cloneDeep(_this.clients));
                    _this.supplier_to_business_ids = tempGroupData.supplier_to_business_ids;
                    _this.group_ids = tempGroupData.group_ids;
                }
                _this.clientsRight = initClientsRight(_.cloneDeep(_this.clients), _this.supplier_to_business_ids, _this.group_ids, _this.shop_ids, _this.business_ids);
                _this.supplier_to_business_ids = fixBusinessIdsContainGroupNotHasChildren(_this.clientsRight, _this.supplier_to_business_ids, _this.group_ids);
                setTimeout(function () {
                    _this.searchRight();
                    _this.rightTreeReady = true;
                    _this.debounceComputedSelectAll && _this.debounceComputedSelectAll();
                }, 300);
            });
        });
    };
    Dialog.prototype.searchRight = function () {
        this.$refs.rightTree.filter(this.rightKeyword);
    };
    Dialog.prototype.close = function () {
        this.$closeDialog();
    };
    Dialog.prototype.applyData = function () {
        if (this.requiredChooseNum) {
            if (this.supplier_to_business_ids.length == 0) {
                this.$message.warning('请选择客户');
                return;
            }
        }
        var data = goodsPriceCreateResultByClientsRight(this.clientsRight, this.supplier_to_business_ids);
        this.$emit("submit", data);
        this.close();
    };
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], Dialog.prototype, "showEmpty", void 0);
    Dialog = __decorate([
        Component({
            watch: {
                leftKeyword: function (val) {
                    this.$refs.tree.filter(val);
                },
                rightKeyword: function (val) {
                    this.$refs.rightTree.filter(val);
                }
            }
        })
    ], Dialog);
    return Dialog;
}(VueDialog));
export default Dialog;
